import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RouteHelperService {

  constructor(private router: Router,
              private route: ActivatedRoute) { }

  getLastPartOfUrl(): string {
    // Get the current URL segments
    const urlSegments = this.router.url.split('/').filter(Boolean);
    // Get the last segment
    const lastSegment = urlSegments[urlSegments.length - 1];
    // Check if the last segment is a number
    if (!isNaN(Number(lastSegment))) {
      // If it is a number, take the second last segment
      return urlSegments[urlSegments.length - 2];
    } else {
      // If it's not a number, take the last segment
      return lastSegment;
    }
  }

  lastPartOfUrlIs(part: string): boolean {
    return this.getLastPartOfUrl() == part
  }

  getIdOfUrl(idName?: string) {
    return Number(this.route.snapshot.paramMap.get(idName ?? 'id'))
  }
}
